// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-form{height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:center;max-width:300px;margin:auto}.login-form .login-img{max-width:50px}.login-form .login-img img{width:100%}.login-form .login-form__title{color:#055FAC;font-size:15px;margin-bottom:5px;margin-top:5px}.login-form .login-form__container{min-width:300px}.mr-05{margin-right:0.5rem}.login-form div.login-form__title.mb-3{margin-bottom:3rem}\n", ""]);
// Exports
module.exports = exports;
